module.exports = __webpack_public_path__ + "media/images/icon-upload-b722a2371006646919b485f7d486081c.svg";